<div class="d-flex flex-column mtm-edit-asset-component p-2 p-sm-3 p-md-4">
  <div class="component-header d-flex flex-column mb-2">
    @if (isNew) {
      <span class="component-title">New Master</span>
    } @else {
      <span class="component-title">Edit asset</span>
    }
  </div>
  <div class="d-flex flex-column section-container" #tvContainer>
    @if (!forVariant) {
      <div class="row">
        <div class="col-12 col-md-8 d-flex flex-column mb-2 mb-sm-3">
          <span class="meta-label _700">Description (Title)</span>
          <input
            type="text"
            class="form-control"
            placeholder="Type your text here..."
            [(ngModel)]="detail"
            [style.font-size]="'12px'"
            maxlength="200" />
        </div>
        <div class="col-12 col-md-4 d-flex flex-column mb-2 mb-sm-3">
          <div class="meta-label _700">Release Date</div>
          <div class="position-relative" style="margin-top: 7px">
            <input
              class="form-control"
              ngbDatepicker
              [(ngModel)]="releaseDate"
              placeholder="XX.X.XXXX"
              #releasedate="ngbDatepicker"
              firstDayOfWeek="1"
              (click)="releasedate.toggle()"
              style="height: 35px; border-radius: 10px; padding-right: 40px" />
            <button
              type="button"
              class="position-absolute btn d-flex align-items-center justify-content-center"
              style="top: 0; right: 0; bottom: 0; width: 40px; cursor: pointer"
              (click)="releasedate.toggle()">
              <img
                ngSrc="assets/img/square-calendar.svg"
                alt="Calendar"
                width="20"
                height="20"
                style="width: 20px; height: 20px" />
            </button>
          </div>
        </div>
        <div
          class="col-12 col-md-4 d-flex flex-column mb-2 mb-sm-3 company-droupdown"
          [style.zIndex]="9999"
          [ngClass]="{ 'has-error': submitted && !funnel }">
          <span class="meta-label _700">Funnel</span>
          <div class="select-wrapper">
            <div class="d-flex align-items-center collaborators-dropdown" #dropdownRef="ngbDropdown" ngbDropdown>
              <button type="button" class="mt-auto d-flex align-items-center p-1 w-100" ngbDropdownToggle>
                <div class="flex-fill me-1 text-start">
                  @if (!funnel) {
                    <span class="c-mtm-full-black text-start text-uppercase f-12">
                      {{ '--Select--' | translate }}
                    </span>
                  } @else {
                    <div class="task-collaborators">
                      <div class="task-collaborator-wrapper d-flex align-items-center">
                        <div class="collaborator-avatar d-flex">
                          <span
                            class="c-mtm-full-black text-start ms-2 _400 _1-line-text-ellipsis me-1 text-size text-uppercase">
                            {{ funnel }}
                          </span>
                        </div>
                      </div>
                    </div>
                  }
                </div>
                <div class="ms-auto pointer me-2">
                  <img ngSrc="assets/svg/arrow.svg" width="12" height="12" alt="Arrow Down" />
                </div>
              </button>
              <div ngbDropdownMenu>
                @for (funnel of funnels; track funnel) {
                  <button
                    type="button"
                    class="d-flex btn align-items-center pointer"
                    (click)="onFunnelSelect(funnel)"
                    ngbDropdownItem>
                    <span class="ms-2 _400">{{ funnel | translate }}</span>
                  </button>
                }
              </div>
            </div>
          </div>
        </div>
        @if (focuses.length > 0) {
          <div class="col-12 col-md-4 d-flex flex-column mb-2 mb-sm-3 company-droupdown" [style.zIndex]="9999">
            <span class="meta-label _700">Focus</span>
            <div class="select-wrapper">
              <div class="d-flex align-items-center collaborators-dropdown" #dropdownRef="ngbDropdown" ngbDropdown>
                <button type="button" class="mt-auto d-flex align-items-center p-1 w-100" ngbDropdownToggle>
                  <div class="flex-fill me-1 text-start">
                    @if (!focus) {
                      <span class="c-mtm-full-black text-start f-12">
                        {{ '--Select--' | translate }}
                      </span>
                    } @else {
                      <div class="task-collaborators">
                        <div class="task-collaborator-wrapper d-flex align-items-center">
                          <div class="collaborator-avatar d-flex">
                            <span
                              class="c-mtm-full-black text-start ms-2 _400 _1-line-text-ellipsis me-1 text-size"
                              style="max-width: 184px">
                              {{ focus }}
                            </span>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                  <div class="ms-auto pointer me-2">
                    <img ngSrc="assets/svg/arrow.svg" width="12" height="12" alt="Arrow Down" />
                  </div>
                </button>
                <div ngbDropdownMenu style="overflow-y: scroll !important">
                  @for (focus of focuses; track focus) {
                    <button
                      type="button"
                      class="d-flex btn align-items-center pointer"
                      (click)="onFocusSelect(focus)"
                      ngbDropdownItem>
                      <span class="ms-2 _400">{{ focus | translate }}</span>
                    </button>
                  }
                </div>
              </div>
            </div>
          </div>
        }
        @if (types.length > 0) {
          <div class="col-12 col-md-4 d-flex flex-column mb-2 mb-sm-3 company-droupdown" [style.zIndex]="1000">
            <span class="meta-label _700">Type</span>
            <div class="select-wrapper">
              <div class="d-flex align-items-center collaborators-dropdown" #dropdownRef="ngbDropdown" ngbDropdown>
                <button type="button" class="mt-auto btn d-flex align-items-center p-1 w-100" ngbDropdownToggle>
                  <div class="flex-fill me-1 text-start">
                    @if (!type) {
                      <span class="c-mtm-full-black text-start f-12">
                        {{ '--Select--' | translate }}
                      </span>
                    } @else {
                      <div class="task-collaborators">
                        <div class="task-collaborator-wrapper d-flex align-items-center">
                          <div class="collaborator-avatar d-flex">
                            <span class="c-mtm-full-black text-start ms-2 _400 _1-line-text-ellipsis me-1 text-size">
                              {{ type }}
                            </span>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                  <div class="ms-auto pointer me-2">
                    <img ngSrc="assets/svg/arrow.svg" width="12" height="12" alt="Arrow Down" />
                  </div>
                </button>
                <div ngbDropdownMenu>
                  @for (type of types; track type) {
                    <button
                      type="button"
                      class="d-flex btn align-items-center pointer"
                      (click)="onTypeSelect(type)"
                      ngbDropdownItem>
                      <span class="ms-2 _400">{{ type | translate }}</span>
                    </button>
                  }
                </div>
              </div>
            </div>
          </div>
        }
        @if (regions.length > 0) {
          <div class="col-12 col-md-4 d-flex flex-column mb-2 mb-sm-3 company-droupdown" [style.zIndex]="9998">
            <span class="meta-label _700">Région</span>
            <div class="select-wrapper">
              <div class="d-flex align-items-center collaborators-dropdown" #dropdownRef="ngbDropdown" ngbDropdown>
                <button type="button" class="mt-auto btn d-flex align-items-center p-1 w-100" ngbDropdownToggle>
                  <div class="flex-fill me-1 text-start">
                    @if (!region) {
                      <span class="c-mtm-full-black text-start f-12">
                        {{ '--Select--' | translate }}
                      </span>
                    } @else {
                      <div class="task-collaborators">
                        <div class="task-collaborator-wrapper d-flex align-items-center">
                          <div class="collaborator-avatar d-flex">
                            <span
                              class="c-mtm-full-black text-start ms-2 _400 _1-line-text-ellipsis me-1 text-size"
                              style="max-width: 184px">
                              {{ region }}
                            </span>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                  <div class="ms-auto pointer me-2">
                    <img ngSrc="assets/svg/arrow.svg" width="12" height="12" alt="Arrow Down" />
                  </div>
                </button>
                <div ngbDropdownMenu style="overflow-y: scroll !important">
                  @for (region of regions; track region) {
                    <button
                      type="button"
                      class="d-flex btn align-items-center pointer"
                      (click)="onRegionSelect(region)"
                      ngbDropdownItem>
                      <span class="ms-2 _400">{{ region | translate }}</span>
                    </button>
                  }
                </div>
              </div>
            </div>
          </div>
        }
        @if (agencys.length > 0) {
          <div class="col-12 col-md-4 d-flex flex-column mb-2 mb-sm-3 company-droupdown" [style.zIndex]="9998">
            <span class="meta-label _700">Agency</span>
            <div class="select-wrapper">
              <div class="d-flex align-items-center collaborators-dropdown" #dropdownRef="ngbDropdown" ngbDropdown>
                <button type="button" class="mt-auto btn d-flex align-items-center p-1 w-100" ngbDropdownToggle>
                  <div class="flex-fill me-1 text-start">
                    @if (!agency) {
                      <span class="c-mtm-full-black text-start f-12">
                        {{ '--Select--' | translate }}
                      </span>
                    } @else {
                      <div class="task-collaborators">
                        <div class="task-collaborator-wrapper d-flex align-items-center">
                          <div class="collaborator-avatar d-flex">
                            <span
                              class="c-mtm-full-black text-start ms-2 _400 _1-line-text-ellipsis me-1 text-size"
                              style="max-width: 184px">
                              {{ agency }}
                            </span>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                  <div class="ms-auto pointer me-2">
                    <img ngSrc="assets/svg/arrow.svg" width="12" height="12" alt="Arrow Down" />
                  </div>
                </button>
                <div ngbDropdownMenu style="overflow-y: scroll !important">
                  @for (agency of agencys; track agency) {
                    <button
                      type="button"
                      class="d-flex btn align-items-center pointer"
                      (click)="onAgencySelect(agency)"
                      ngbDropdownItem>
                      <span class="ms-2 _400">{{ agency | translate }}</span>
                    </button>
                  }
                </div>
              </div>
            </div>
          </div>
        }
        <div class="col-12 col-md-4 d-flex flex-column mb-2 mb-sm-3 company-droupdown" [style.zIndex]="999">
          <span class="meta-label _700">Product</span>
          <input
            type="text"
            class="form-control"
            placeholder="Type here.."
            [(ngModel)]="product"
            [style.font-size]="'12px'"
            maxlength="50" />
        </div>
      </div>
      @if (availableCategories.length > 0) {
        <div>
          <span class="create-new-label m-0">Categories</span>
          <div class="d-flex bet-list-container flex-wrap">
            <button
              type="button"
              (click)="selectCategory('VIDEO')"
              [ngClass]="{ selected: selectedCategories?.indexOf('VIDEO') > -1 }"
              class="bet-list d-flex flex-column btn align-items-center justify-content-center p-2 m-1 m-sm-2 pointer">
              @if (selectedCategories?.indexOf('VIDEO') > -1) {
                <i class="ms-auto me-auto mt-2 me-1 mb-1 mtm-icon mtm-icon-white-check"></i>
              }
              <span class="meta-label text-uppercase d-flex align-items-center ms-auto me-auto me-1 mt-0 _700"
                >VIDEO</span
              >
            </button>
            <button
              type="button"
              (click)="selectCategory('STILL')"
              [ngClass]="{ selected: selectedCategories?.indexOf('STILL') > -1 }"
              class="bet-list d-flex flex-column btn align-items-center justify-content-center p-2 m-1 m-sm-2 pointer">
              @if (selectedCategories?.indexOf('STILL') > -1) {
                <i class="ms-auto me-auto mt-2 me-1 mb-1 mtm-icon mtm-icon-white-check"></i>
              }
              <span class="meta-label text-uppercase d-flex align-items-center ms-auto me-auto me-1 mt-0 _700"
                >STILL</span
              >
            </button>
          </div>
        </div>
      }
      <div [ngClass]="{ 'has-error': submitted && !selectedBets?.length && !otherBet }">
        <span class="create-new-label m-0">Platform</span>
        <div class="d-flex bet-list-container flex-wrap">
          @for (bet of betList.slice(0, 10); track bet) {
            <button
              type="button"
              (click)="selectBet(bet)"
              [ngClass]="{ selected: selectedBets?.indexOf(bet) > -1 }"
              class="bet-list d-flex flex-column btn align-items-center justify-content-center p-2 m-1 m-sm-2 pointer">
              @if (selectedBets?.indexOf(bet) > -1) {
                <i class="ms-auto me-auto mt-2 me-1 mb-1 mtm-icon mtm-icon-white-check"></i>
              }
              <i class="ms-auto me-auto mt-3 me-1 mb-1 mtm-icon mtm-icon-{{ bet.toLowerCase() }}"></i>
              <span class="meta-label text-uppercase d-flex align-items-center ms-auto me-auto me-1 mt-0 _700">{{
                bet
              }}</span>
            </button>
          }
        </div>
      </div>
      <div class="d-flex flex-column">
        <div class="other d-flex flex-column justify-content-start pb-1 pb-sm-2" [style.border]="'none'">
          <span class="_700" style="font-size: 12px">Other</span>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="otherBet"
            maxlength="15"
            placeholder="Name it here..."
            [style.height]="'35px'"
            [style.width]="'100%'"
            [style.max-width]="'219px'"
            [style.font-size]="'12px'"
            [style.padding]="'10px'" />
        </div>
      </div>

      <div class="d-flex row">
        <div class="col-12 col-md-5 d-flex flex-column mb-2 mb-sm-3 format-dropdown">
          <div class="d-flex flex-column mb-2 mb-sm-3">
            <span class="create-new-label">Length</span>
            <div class="length-input-container d-flex align-items-center position-relative">
              <input
                type="text"
                class="length-input text-uppercase"
                [value]="lengthValue"
                (blur)="onInputChange($event)"
                [class.error]="showError" />
              <span class="position-absolute length-unit-label">seconds</span>
              <div class="arrow-buttons">
                <button
                  type="button"
                  (click)="increaseLength()"
                  [disabled]="lengthValueInSeconds === 90"
                  class="arrow-button arrow-button--up">
                  <img ngSrc="assets/svg/arrow-up.svg" width="12" height="12" alt="Up" />
                </button>
                <button
                  type="button"
                  (click)="decreaseLength()"
                  [disabled]="lengthValueInSeconds === 1"
                  class="arrow-button arrow-button--down">
                  <img ngSrc="assets/svg/arrow-down-new.svg" width="12" height="12" alt="Down" />
                </button>
              </div>
              <p class="position-absolute length-status">{{ lengthStatus }}</p>
            </div>
            @if (showError) {
              <small class="text-danger">Invalid length value!</small>
            }
          </div>
        </div>
        <div class="col-12 col-md-5 d-flex flex-column mb-2 mb-sm-3 format-dropdown">
          <span class="meta-label _700">Format</span>
          <div class="select-wrapper">
            <div class="d-flex align-items-center collaborators-dropdown" #dropdownRef="ngbDropdown" ngbDropdown>
              <button type="button" class="mt-auto btn d-flex align-items-center p-1 w-100" ngbDropdownToggle>
                <div class="flex-fill me-1 text-start">
                  @if (!selectedFormat) {
                    <span class="c-mtm-full-black text-start f-12">
                      {{ '--Select--' | translate }}
                    </span>
                  } @else {
                    <div class="task-collaborators">
                      <div class="task-collaborator-wrapper d-flex align-items-center">
                        <div class="collaborator-avatar d-flex">
                          <span
                            class="c-mtm-full-black text-start ms-2 _400 _1-line-text-ellipsis me-1 text-size"
                            [innerHTML]="getFormatDisplay(selectedFormat)">
                          </span>
                        </div>
                      </div>
                    </div>
                  }
                </div>
                <div class="ms-auto pointer me-2">
                  <img ngSrc="assets/svg/arrow.svg" width="12" height="12" alt="Arrow Down" />
                </div>
              </button>
              <div ngbDropdownMenu>
                @for (format of availableFormat; track format) {
                  <button
                    type="button"
                    class="d-flex btn align-items-center pointer"
                    (click)="selectFormat(format)"
                    ngbDropdownItem>
                    <span class="ms-2 _400" [innerHTML]="getFormatDisplay(format)"></span>
                  </button>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    <mtm-edit-asset-technical-variants
      [tempAssets]="tempAssets"
      [forVariant]="forVariant"
      [submitted]="submitted"
      [betsOptions]="betsOptions"
      [types]="types"
      [focuses]="focuses"
      [availableCategories]="availableCategories"
      [lengthOptions]="lengthOptions"
      [formatOptions]="formatOptions"
      [formatDisplayMap]="formatDisplayMap"
      (assetUpdated)="onVariantAssetUpdated($event)"
      (delete)="onDelete($event)"
      (addVariant)="addNewTechVariant()">
    </mtm-edit-asset-technical-variants>
  </div>
</div>
<div class="footer-component d-flex flex-column flex-md-row align-items-center justify-content-center">
  <div class="me-0 me-md-2 mb-2 mb-md-0 button-wrapper" style="opacity: 0.5">
    <button type="button" class="btn mtm-button button-cancel _700 c-mtm-full-black" (click)="cancel()">CANCEL</button>
  </div>
  <div class="me-0 me-md-2 button-wrapper">
    <button type="button" class="btn mtm-button b-mtm-black _700 c-mtm-full-white" (click)="save()">SAVE</button>
  </div>
</div>
